import Slider from '@dtvgo/slider';
import './VolumeBar.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

/* External */

function VolumeBar(_ref) {
  var volume = _ref.volume,
    setVolume = _ref.setVolume,
    isMuted = _ref.isMuted;
  var minValue = 0;
  var maxValue = 100;
  return /*#__PURE__*/jsxs(Slider, {
    className: "dtv-common-c-volume-bar",
    minValue: minValue,
    maxValue: maxValue,
    onSetValue: setVolume,
    vertical: true,
    dragFromOutside: true,
    stopClickPropagation: true,
    value: isMuted ? 0 : volume,
    children: [/*#__PURE__*/jsx(Slider.Fill, {}), /*#__PURE__*/jsx(Slider.Dot, {})]
  });
}
VolumeBar.defaultProps = {
  volume: 0,
  isMuted: false,
  setVolume: function setVolume() {}
};

export { VolumeBar as default };
//# sourceMappingURL=VolumeBar.js.map
